import { Typography as T, cssThemedValue } from '@creditornot/cb-ingredients';
import { Empty } from '@creditornot/cb-placeholders';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const Root = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: auto;
`;
const Message = styled(T.Title1)`
  color: ${cssThemedValue('textSecondary')};
`;

const EmptyView = () => (
  <Root>
    <Empty />
    <Message>
      <FormattedMessage id="venue-availability-status.table.empty-message" />
    </Message>
  </Root>
);

export default EmptyView;
